'use es6';

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAndCopyGeneratedHubl } from 'ContentEditorUI/redux/actions/hublActions';
import { getFetchGeneratedHublRequest } from 'ContentEditorUI/redux/selectors/requestStatesSelectors';
import { requestStarted, requestSucceeded, requestFailed } from 'redux-request-state/util/requestStateCheckers';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const CopyAsHubLContainer = () => {
  const dispatch = useDispatch();
  const requestStatus = useSelector(getFetchGeneratedHublRequest);
  const shouldFetchHubl = requestStarted(requestStatus);
  const shouldShowHublCopiedAlert = requestSucceeded(requestStatus);
  const shouldShowHublCopyFailedAlert = requestFailed(requestStatus);
  useEffect(() => {
    if (shouldShowHublCopyFailedAlert) {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "editor.copyAsHubL.info.failure"
        }),
        type: 'warning',
        timeout: 3000
      });
    }
  }, [shouldShowHublCopyFailedAlert]);
  useEffect(() => {
    if (shouldShowHublCopiedAlert) {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "editor.copyAsHubL.info.success"
        }),
        type: 'success',
        timeout: 3000
      });
    }
  }, [shouldShowHublCopiedAlert]);
  useEffect(() => {
    if (shouldFetchHubl) {
      dispatch(fetchAndCopyGeneratedHubl());
    }
  }, [shouldFetchHubl, dispatch]);
  return null;
};
export default CopyAsHubLContainer;